import { UtilsModule } from '@anecdotes/design-system/utils';
import { LoadersModule } from '@anecdotes/design-system/loaders';
import { ModalsModule } from '@anecdotes/design-system/modals';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { DynamicFormModule } from '@anecdotes/dynamic-form';
import { ComponentSwitcherModule } from '@anecdotes/design-system/component-switcher';
import { UserLogoComponent } from './components/user-logo/user-logo.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { RouterModule } from '@angular/router';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ReactiveFormsModule } from '@angular/forms';
import { FormControlsModule } from '@anecdotes/design-system/form-controls';
import { DirectivesModule } from '@anecdotes/design-system/directives';
import { AuthCoreModule } from '@anecdotes/auth-core';
import { DataManipulationModule } from '@anecdotes/design-system/data-manipulation';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    NgbTooltipModule,
    SvgIconsModule,
    ComponentSwitcherModule,
    RouterModule,
    NgbPopoverModule,
    PerfectScrollbarModule,
    ReactiveFormsModule,
    DynamicFormModule,
    ButtonsModule,
    ModalsModule,
    LoadersModule,
    FormControlsModule,
    UtilsModule,
    DirectivesModule,
    AuthCoreModule,
    DataManipulationModule,
  ],
  declarations: [
    UserLogoComponent,
    UserDetailsComponent
  ],
  exports: [
    UserLogoComponent,
    UserDetailsComponent
  ],
})
export class UserProfileModule {}
